import React from 'react';
import {Link} from 'react-router-dom';
import {Card, CardBody, Col, Container, Row} from 'reactstrap';

import notFoundImg from '../../../assets/images/startman.svg';
import logo from '../../../assets/images/logo/logo_login.svg';

const ErrorPage = ({title, message, detail, refreshButton, classNames}) => {
    return (
        <React.Fragment>
            <div className='position-fixed w-100 h-100 authentication-bg'>
                <div className={"account-pages mb-5 " + classNames}>
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={5}>
                                <Card className='box-shadow-none'>
                                    <div className="card-header pt-4 pb-4 text-center bg-danger">
                                        <Link to="https://akadoc.ai">
                                            <span>
                                                <img src={logo} alt="" height="32"/>
                                            </span>
                                        </Link>
                                    </div>
                                    <CardBody>
                                        <div className="text-center">
                                            <img src={notFoundImg} height="90" alt=""/>
                                            <h2 className="text-error mt-4">{title}</h2>
                                            <h5 className="text-uppercase text-danger mt-3">{message}</h5>
                                            {refreshButton && (
                                                <>
                                                    <p className="text-muted mt-3">{detail}</p>
                                                    <Link className="btn btn-outline-danger mt-3" to="/">
                                                        <i className="mdi mdi-refresh"/> Refresh Page
                                                    </Link>
                                                </>
                                            )}
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ErrorPage;